import { combineReducers } from "redux";
import { AnyAction, Reducer } from "@reduxjs/toolkit";
import authReducer from "./auth";
import appReducer from "./app";

export * from "./app";
export * from "./auth";

const mainReducer = combineReducers({
  auth: authReducer,
  app: appReducer,
});

export type RootState = ReturnType<typeof mainReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === "RESET") {
    // reset state
    state = {} as RootState;
    // reset local storage
    localStorage.clear();
  }
  return mainReducer(state, action);
};
export default rootReducer;
